<template>
<div class="home">
    <MyHeader/>  
    <Menu ref="menu"/>
    <div class="router-view">
      <router-view ref="pro-list"/>
    </div>    
  </div>
</template>

<script>
import { default as MyHeader } from '@/components/MyHeader.vue'
import { default as Menu } from '@/components/Menu.vue'
export default {
  name: 'Home',
  components: {
     MyHeader,
     Menu,
  },
  props: {},
  data() {
    return {
      testData: null,
    }
  },
  created() {},
  mounted() {
    
  },
  methods: {
   
  },
}
</script>

<style lang="scss">
.home {
    height: 100%;
    background: #F1F1F1;
}
</style>
